import React from 'react'
import styles from './News.module.scss'
// components
import Title from '../images/svg/head_news.svg'

const email = 'info@happysunny.net';

const News = () => (
    <section name="news" className={styles.wrapper}>
        <div className={styles.container}>
            <h2 className="sr-only">最新情報</h2>
            <div className={styles.head}>
                <Title />
            </div>
            <div className={styles.items}>
            <div className={styles.item}>
                    <div className={styles.itemDate}>2019.03.07</div>
                    <div className={styles.itemBody}>
                        <span className={styles.itemHead}>
                            【募集】業務提携パートナースタッフ!
                        </span>
                        <div className={styles.itemDesc}>
                            現在、クリエイティブ事業部の業務提携パートナースタッフを募集しております。<br />
                            <ul>
                                <li>映像カメラマン</li>
                                <li>映像ディレクター</li>
                                <li>映像エディター(Premier Pro, After Effectsなど経験がある方 優遇)</li>
                                <li>3DCGディレクター</li>
                                <li>スチールカメラマン</li>
                            </ul>
                            詳しくは<a href={`mailto:${email}`} title={email}>{email}</a>までご連絡ください。
                        </div>
                        <div className={styles.tags}>
                            <div className={styles.tag}>
                                News
                            </div>
                            <div className={styles.tag}>
                                Recruitment
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.item}>
                    <div className={styles.itemDate}>2020.03.05</div>
                    <div className={styles.itemBody}>
                        <span className={styles.itemHead}>
                            ウェブサイトを開設しました。
                        </span>
                        <div className={styles.tags}>
                            <div className={styles.tag}>
                                News
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
)

export default News;
